import React from "react";
import { ClickClose, Icon, Warning } from "@culturehq/components";

import { Trans } from "app/utils";

import SearchResult from "./SearchResult";

const SearchResults = ({ searchResults, onClearSearchResults }) => {
  if (searchResults === null) {
    return null;
  }

  if (searchResults.length === 0) {
    return (
      <Warning>
        <Icon icon="help-circled" />
        <Trans>No results, please try again.</Trans>
      </Warning>
    );
  }

  return (
    <ClickClose className="chq-nav--results" onClose={onClearSearchResults}>
      {searchResults.map(searchResult => (
        <SearchResult
          key={`${searchResult.type}/${searchResult.id}`}
          result={searchResult}
          onClearSearchResults={onClearSearchResults}
        />
      ))}
    </ClickClose>
  );
};

export default SearchResults;
